"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corte-brugnatella": {
    "c2ea3825": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "castelvetto": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b358991": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "lago": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "21f32b1e": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "lupi": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "55959656": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "marsaglia": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aeff796f": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "metteglia": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8eb3be99": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "ozzola-pieve": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "98c0e0a4": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "rovaiola": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f23a50d0": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "2b2be6aa",
      "slug": "corte-brugnatella",
      "name": "Corte Brugnatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;